import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { completeAuth } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (res.ok) completeAuth(await res.json());
      } catch {} finally {
        window.history.replaceState(null, "", location.pathname);
        navigate(location.pathname, { replace: true });
      }
    })();
  }, [location, navigate, completeAuth]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-xir-dark" data-testid="auth-callback">
      <span className="font-display text-2xl tracking-[0.1em] text-xir-gold">CAFÉXIR</span>
    </div>
  );
}
